import React, { useState } from 'react';
import { Square, Row, Column } from '@grubhubprod/gh-cookbook-react/dist';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import {
  SortableColumn,
  SortFields,
  SortOrder,
} from 'src/components/Table/SortableColumn';

export type SortConfig = {
  sortField: SortFields;
  sortOrder: SortOrder;
};

export const defaultOrderHistorySortConfig: SortConfig = {
  sortField: SortFields.WHEN_FOR,
  sortOrder: SortOrder.DESC,
};

export type TableHeaderProps = {
  isCorpExpenseEnabled: boolean;
  onSortColumn: (field: SortFields, order: SortOrder) => void;
  shouldDisplayDepartments: boolean;
  shouldDisplayLocations: boolean;
};

export default function TableHeader({
  isCorpExpenseEnabled,
  onSortColumn,
  shouldDisplayLocations,
  shouldDisplayDepartments,
}: TableHeaderProps): JSX.Element {
  const [sortConfig, setSortConfig] = useState<SortConfig>(
    defaultOrderHistorySortConfig
  );

  function onSort(sortField: SortFields, sortOrder: SortOrder) {
    setSortConfig({
      sortOrder,
      sortField,
    });

    onSortColumn(sortField, sortOrder);
  }
  return (
    <Square>
      <Row gutter={4} alignItems="center">
        <Column phone={2} gutter={4}>
          <SortableColumn
            label="Delivery date"
            previousSortOrder={sortConfig.sortOrder}
            sortField={SortFields.WHEN_FOR}
            previousSortField={sortConfig.sortField}
            onSortColumnClick={onSort}
          />
        </Column>
        <Column phone={2} gutter={4}>
          <SortableColumn
            label="Name"
            previousSortOrder={sortConfig.sortOrder}
            sortField={SortFields.DINER_NAME}
            previousSortField={sortConfig.sortField}
            onSortColumnClick={onSort}
          />
        </Column>
        <Column phone={1} gutter={4}>
          <Copy variant="body" color="secondaryText">
            Total
          </Copy>
        </Column>
        <Column phone={1} className="ellipsisOverflow" gutter={4}>
          <Copy variant="body" color="secondaryText">
            Order type
          </Copy>
        </Column>
        {shouldDisplayDepartments && (
          <Column
            style={{ flex: '3 1' }}
            className="ellipsisOverflow"
            gutter={8}
          >
            <Copy variant="body" color="secondaryText">
              Department
            </Copy>
          </Column>
        )}

        {shouldDisplayLocations && (
          <Column
            gutter={8}
            style={{ flex: '3 1' }}
            className="ellipsisOverflow"
          >
            <Copy variant="body" color="secondaryText">
              Location
            </Copy>
          </Column>
        )}
        {isCorpExpenseEnabled && (
          <Column
            style={{ flex: '3 1' }}
            className="ellipsisOverflow"
            gutter={8}
          >
            <SortableColumn
              label="Expense code"
              previousSortOrder={sortConfig.sortOrder}
              sortField={SortFields.EXPENSE_CODE}
              previousSortField={sortConfig.sortField}
              onSortColumnClick={onSort}
            />
          </Column>
        )}
        <Column style={{ flex: '3 1' }} className="ellipsisOverflow" gutter={4}>
          <SortableColumn
            label="Restaurant"
            previousSortOrder={sortConfig.sortOrder}
            sortField={SortFields.RESTAURANT}
            previousSortField={sortConfig.sortField}
            onSortColumnClick={onSort}
          />
        </Column>
        <Column gutter={0} style={{ flex: '1 1' }}>
          <Copy
            variant="body"
            color="secondaryText"
            textAlign="end"
            display="block"
          >
            Receipt
          </Copy>
        </Column>
      </Row>
    </Square>
  );
}
